import { render } from "./Servicepoints.vue?vue&type=template&id=9e03e946&scoped=true"
import script from "./Servicepoints.vue?vue&type=script&lang=js"
export * from "./Servicepoints.vue?vue&type=script&lang=js"

import "./Servicepoints.vue?vue&type=style&index=0&id=9e03e946&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e03e946"]])

export default __exports__